<!--恒岳读书会-->
<template>
    <div class="event-nav-container">
        <div class="museum-title-container" v-show="showMode==='page'">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container">恒岳读书会</div>
                <div class="l-b-museum-title-container">多元阅读资源养成终身习惯</div>
            </div>
            <div class="r-museum-title-container">
                <div  class="back-btn-container" @click="backReadMuseum" >⇦返回</div>
            </div>
        </div>
        <div class="event-content-container" v-show="showMode==='page'">
            <div class="event-content-top-container">
                <div class="event-item-container" v-for="item in itemList.slice(0,1)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg1">
                        <div class="event-title">{{item.itemMonth}}启新</div>
                        <div class="event-desc">遇见美好</div>
                        <div class="event-desc">新年共读启智</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(1,2)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg2">
                        <div class="event-title">{{item.itemMonth}}年味</div>
                        <div class="event-desc">浸润家国</div>
                        <div class="event-desc">品读传统温情</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(2,3)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg3">
                        <div class="event-title">{{item.itemMonth}}春风</div>
                        <div class="event-desc">致敬榜样</div>
                        <div class="event-desc">传递向上力量</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(3,4)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg4">
                        <div class="event-title">{{item.itemMonth}}清和</div>
                        <div class="event-desc">书香致远</div>
                        <div class="event-desc">品读经典名著</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(4,5)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg5">
                        <div class="event-title">{{item.itemMonth}}暖阳</div>
                        <div class="event-desc">感恩成长</div>
                        <div class="event-desc">诉说温情与担当</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(5,6)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg6">
                        <div class="event-title">{{item.itemMonth}}逐梦</div>
                        <div class="event-desc">不负韶华</div>
                        <div class="event-desc">助力成长启航</div>
                    </div>
                </div>
            </div>
            <div class="event-content-bottom-container" v-for="item in itemList.slice(6,7)" :key="item" @click="pageMyjr(item)">
                <div class="event-item-container">
                    <div class="event-item read-bg7">
                        <div class="event-title">{{item.itemMonth}}盛夏</div>
                        <div class="event-desc">探索未知</div>
                        <div class="event-desc">拓宽认知边界</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(7,8)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg8">
                        <div class="event-title">{{item.itemMonth}}静思</div>
                        <div class="event-desc">沉淀自我</div>
                        <div class="event-desc">深耕阅读与反思</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(8,9)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg9">
                        <div class="event-title">{{item.itemMonth}}师恩</div>
                        <div class="event-desc">笃行育人</div>
                        <div class="event-desc">致敬教育初心</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(9,10)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg10">
                        <div class="event-title">{{item.itemMonth}}秋实</div>
                        <div class="event-desc">家国同庆</div>
                        <div class="event-desc">感悟时代荣光</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(10,11)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg11">
                        <div class="event-title">{{item.itemMonth}}秋韵</div>
                        <div class="event-desc">笔墨生香</div>
                        <div class="event-desc">读写结合共进</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(11,12)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item read-bg12">
                        <div class="event-title">{{item.itemMonth}}收官</div>
                        <div class="event-desc">蓄力前行</div>
                        <div class="event-desc">总结与展望</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" v-show="showMode==='detail'">
            <read-page :item-id="itemId" :item-name="itemName" :mark-info="markInfo"
                       @change-mode="changeModel" />
        </div>
    </div>
</template>
<script>
import {listItemByMuseum} from "@/api/admin/item"
import readPage from "@/components/read/readPage.vue";

export default {
    name:'readEventClub',
    components:{readPage},
    props:{
        museumId:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        museumId(newValue,oldValue){
            this.queryItemList();
        },
        markInfo(newValue,oldValue){
            this.queryItemList();
        },
    },
    mounted() {
    },
    created() {

    },
    data() {
        return {
            showMode:'page',
            itemList:[],
            itemId:'',
            itemName:'',
            markInfo:'pageSub',
        }
    },
    methods: {
        queryItemList(){
            listItemByMuseum({ museumKey: this.museumId }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode);
        },
        pageMyjr(item){
            this.itemId = item.itemId;
            this.itemName = item.itemName;
            this.markInfo = this.markInfo+new Date();
            this.showMode = 'detail';
            this.$emit('change-mode',this.showMode);
        },
        backReadMuseum(){
            this.$emit('back-read-museum', "homePage");
        },
    }
}
</script>
<style>
.event-nav-container{
    width: 100%;
    height: calc(100vh - 90px);
    background: rgba(255,255,255,.5);

}
.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.event-content-container{
    width: 100%;
    height: calc(100% - 70px);
    padding: 20px;
    box-sizing: border-box;
}
.event-content-top-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-item-container{
    width: 16.6%;
    height: 100%;
    display: flex;
    border: 10px;
    box-sizing: border-box;
}
.event-item{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.read-bg1{
    background-image: url("../../assets/dsh/dsh_1.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg2{
    background-image: url("../../assets/dsh/dsh_2.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg3{
    background-image: url("../../assets/dsh/dsh_3.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg4{
    background-image: url("../../assets/dsh/dsh_4.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg5{
    background-image: url("../../assets/dsh/dsh_5.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg6{
    background-image: url("../../assets/dsh/dsh_6.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg7{
    background-image: url("../../assets/dsh/dsh_7.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg8{
    background-image: url("../../assets/dsh/dsh_8.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg9{
    background-image: url("../../assets/dsh/dsh_9.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg10{
    background-image: url("../../assets/dsh/dsh_10.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg11{
    background-image: url("../../assets/dsh/dsh_11.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg12{
    background-image: url("../../assets/dsh/dsh_12.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.event-content-bottom-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-title{
    width: 100%;
    height: 50px;
    line-height: 60px;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    color: #0d55a4;
}
.event-desc{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #9a9a9a;
}
</style>